module.exports = __webpack_public_path__ + "static/media/delete-white.99dac057.svg";